import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import TemplateNameCreateForm from './TemplateNameCreateForm';

const styles = () => ({
  form: {
    padding: '35px 100px',
  },
});

const TemplateNameCreateDialog = ({
  open,
  onClose,
  onSubmitSuccess,
  actions,
  submitting,
  form,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Template Create
      </Typography>
    </DialogTitle>
    <DialogContent>
      <TemplateNameCreateForm
        className={classes.form}
        form={form}
        onSubmitSuccess={(values) => {
          onClose();
          onSubmitSuccess(values);
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => actions.submit(form)}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Continue
      </Button>
    </DialogActions>
  </Dialog>
);

TemplateNameCreateDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  form: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

TemplateNameCreateDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(TemplateNameCreateDialog),
);



// WEBPACK FOOTER //
// ./src/components/settings/TemplateNameCreateDialog/TemplateNameCreateDialog.js